import { type PropsWithChildren, type Ref } from 'react';

import { clsx } from 'clsx';

import styles from './PageLayout.module.scss';

const Container = ({ children }: PropsWithChildren) => (
  <div className={styles.container} data-page-layout>
    {children}
  </div>
);

const Body = ({ children, className, ref }: PropsWithChildren<{ className?: string; ref?: Ref<HTMLDivElement> }>) => (
  <div ref={ref} className={clsx(styles.body, className)}>
    {children}
  </div>
);

const Footer = ({ children, className }: PropsWithChildren<{ className?: string }>) => (
  <div className={clsx(styles.footer, className)}>{children}</div>
);

const PageLayout = Object.assign(Container, { Body, Footer });

export default PageLayout;
